import { render, staticRenderFns } from "./AddSize.vue?vue&type=template&id=12eaf44d&scoped=true"
import script from "./AddSize.vue?vue&type=script&lang=js"
export * from "./AddSize.vue?vue&type=script&lang=js"
import style0 from "./AddSize.vue?vue&type=style&index=0&id=12eaf44d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12eaf44d",
  null
  
)

export default component.exports